import * as Sentry from '@sentry/react';
import type { ErrorInfo, PropsWithChildren } from 'react';
import { Component } from 'react';

export class DescopeErrorBoundary extends Component<PropsWithChildren, { hasError: boolean }> {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    Sentry.captureException(error, { extra: { source: 'descope', componentStack: info.componentStack } });
  }

  render() {
    if (this.state.hasError) return null;
    return this.props.children;
  }
}
